import ExperimentManager from '@sharethrough/rendering-experiments';
import { ButlerResponse } from 'modules/butler/response';

export const experimentManager = new ExperimentManager<{ butlerResponse: ButlerResponse }>();
